import React from 'react';

export default function SearchBox({ value, onChange, onSubmit, loading }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim() && onSubmit) onSubmit(value.trim());
  };

  return (
    <form className="search-box" onSubmit={handleSubmit}>
      <div className="search-input-wrapper">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input
          type="text"
          placeholder="Digite o nome ou sobrenome"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <button type="submit" disabled={loading || !value.trim()}>
        {loading ? 'BUSCANDO...' : 'LOCALIZAR'}
      </button>
    </form>
  );
}
